<main>
  <div class="container container-width">
    <div class="topheadtitle">
      <h4>Delivery Annual Report @if (showReportResults) {
        <span> - {{year}}</span>
      }</h4>
    </div>

    @if (!showReportResults) {
      <div class="form-box w-100 d-flex p-2">
        <label for="selectYear" class="mr-1">Report Year</label>
        <select (change)="selectYear($any($event.target).value)" [(ngModel)]="year" id="selectYear"
          title="select year" class="option-d ml-auto">
          @for (years of listOfYearsOptions; track years) {
            <option [value]="years">{{years}}</option>
          }
        </select>
      </div>
      <div class="mt-3">
        <button type="button" class="btn btn-primary btn-sm" (click)="showReportResults = true;getAnnualReport()">
          Generate Report
        </button>
        <button type="button" class="btn btn-primary btn-sm ml-3" (click)="year = 2024">Reset</button>
      </div>
    }

    @if (showReportResults) {
      <div class="table-container">
        @if (listAnnualReport.length > 0) {
          <button type="button" class="btn btn-primary btn-sm mb-1"
            (click)="excelExport()">
            Export To Excel
          </button>
        }
        <table class="table" summary="Delivery Annual Report Results">
          <caption>eCitation Delivery Annual Report</caption>
          <thead>
            <tr>
              <th scope="col">MONTH/YEAR</th>
              <th scope="col">DNR</th>
              <th scope="col">DAIT-PROTECT</th>
              <th scope="col">COWS</th>
              <th scope="col">CCAP</th>
              <th scope="col">MUNICIPAL COURT</th>
              <th scope="col">LOCAL COURT</th>
              <th scope="col">NO ACTION</th>
              <th scope="col">DELIVERED TOTAL</th>
            </tr>
          </thead>
          <tbody>
            @for (item of listAnnualReport; track item) {
              <tr>
                <td>{{item.date}}</td>
                <td>{{item.dnr}}</td>
                <td>{{item.daProtect}}</td>
                <td>{{item.cows}}</td>
                <td>{{item.ccap}}</td>
                <td>{{item.muni}}</td>
                <td>{{item.nowhere}}</td>
                <td>{{item.ears}}</td>
                <td>{{item.delivered}}</td>
              </tr>
            }
          </tbody>
        </table>
        <br />
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <span>{{listAnnualReport.length}} items found, displaying {{getCurrentPageTotal()}} of
            {{listAnnualReport.length}}</span>
          </div>
          <ngb-pagination [collectionSize]="listAnnualReport.length" [(page)]="currentPage" [ellipses]="true"
            [maxSize]="10" (pageChange)="onPageChange(currentPage)" [pageSize]="10" [boundaryLinks]="true"
          aria-label="Delivery annual report pagination"></ngb-pagination>
          <br />
          <button type="button" class="btn btn-outline-primary" (click)="showReportResults = false;">
            Go back to previous page
          </button>
        </div>
      </div>
    }
  </div>
</main>